<template>
    <div>
        <haederTrial></haederTrial>
        <div class="trial-content">
            <div class="flex justify-between align-center">
                <div class="content-title">
                    <div class="title-line"></div>
                    <div class="title">方案详情</div>
                </div>
                <el-button @click="setPayment" class="buy-button" type="primary"><i class="el-icon-shopping-cart-2"></i>
                    立即购买</el-button>
            </div>
            <div class="finish-time">完成时间：2022年12月11日</div>
            <div class="content-img">
                <img v-if="imgIndex < total - 1" :src="imgUrl[imgIndex]" />
                <div v-else class="end-page">
                    <div class="tips">试读结束，请购买阅读～</div>
                    <el-button @click="setPayment" class="buy-button" type="primary">点击付费</el-button>
                </div>
            </div>
            <div class="flex justify-content">
                <el-pagination background :page-size="1" layout="prev, pager, next" @current-change="setCurrent"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <payment ref="payment"></payment>
        <footers></footers>
    </div>
</template>
<script>
import haederTrial from '../../components/haeder-trial.vue'
import footers from '../../components/footer.vue'
import payment from '../../components/payment.vue'
export default {
    components: { haederTrial, footers, payment },
    data() {
        return {
            tabList: [{
                url: '',
                label: '首页'
            }, {
                url: '',
                label: '解决方案'
            }, {
                url: '',
                label: '数据产品'
            }, {
                url: '',
                label: '研究报告'
            }, {
                url: '',
                label: '新闻文章'
            }, {
                url: '',
                label: '关于我们'
            }],
            tabIndex: 3,
            imgUrl: [],
            total: 0,
            imgIndex: 0,
            dialogVisible: true,
            detail: null,
            type: ''
        }
    },
    created() {
        this.type = this.$route.query.type
        this.getInfo(this.$route.query.id)

    },
    methods: {
        setTab(index) {
            this.tabIndex = index
        },
        getInfo(id) {
            let that = this
            if (this.type != 3) {
                this.apis.trialCase({ id: id, userId: this.$store.state.userId }).then(res => {
                    this.detail = res.data
                    this.imgUrl = res.data.imageUrl.split(';')
                    this.total = res.data.imageUrl.split(';').length
                    console.log(res.data.isBuy)
                    if (res.data.isBuy == 1) {
                        that.$router.go(-1)
                    }
                })
            } else {
                this.apis.trialStudy({ id: id, userId: this.$store.state.userId }).then(res => {
                    this.detail = res.data
                    this.imgUrl = res.data.imageUrl.split(';')
                    this.total = res.data.imageUrl.split(';').length
                    if (res.data.isBuy == 1) {
                        this.$router.go(-1)
                    }
                })
            }

        },
        setCurrent(e) {
            this.imgIndex = e - 1
        },
        // 立即购买
        setPayment() {
            let data = {
                status: true,
                price: this.detail.webPrice,
                userId: this.$store.state.userId,
                reportId: this.detail.id,
                reportType: this.type,
                description: this.detail.title
            }
            this.$refs.payment.setVisible(data)
        }
    }
}

</script>
<style>
.menu-bg {
    width: 100%;
    height: 84px;
    background: #242627;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* padding: 0 160px; */
    position: relative;
    top: 0;
    left: 0;
}

.menu-bg .logo {
    width: 74px;
    height: 58px;
    margin-left: 5%;
}

.tab {
    display: flex;
    margin-right: 5%;
}

.tab .tab-item {
    margin: 0 30px;
    color: #fff;
    font-size: 16px;
    text-decoration: none;
}

.tab .tab2-item {
    color: #838B93;
    font-size: 16px;
    text-decoration: none;
}

.tab .active-line {
    font-size: 16px;
    font-weight: 600;
    border-bottom: 3px solid #fff;
    padding-bottom: 5px;
    width: 30px;
    height: 2px;
    /* display: none; */
}

.tab .active2-line {
    font-size: 16px;
    font-weight: 600;
    border-bottom: 2px solid #3D82F6;
    padding-bottom: 5px;
    width: 30px;
    height: 2px;
    /* display: none; */
}

.trial-content {
    width: 1200px;
    margin: 0 auto;
    margin-top: 148px;
    margin-bottom: 51px;
}

.content-title {
    display: flex;
    align-items: center;
}

.content-title .title-line {
    width: 7px;
    height: 24px;
    background: #435696;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
}

.content-title .title {
    font-size: 24px;
    font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
    font-weight: 600;
    color: #000000;
    margin-left: 6px;
    line-height: 19px;
}

.buy-button {
    width: 104px;
    height: 36px;
    background: linear-gradient(147deg, #00C2FF 0%, #006AE5 100%);
    border-radius: 6px 6px 6px 6px;
    display: flex;
    justify-content: center;
}

.trial-content .finish-time {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #838B93;
    line-height: 19px;
    margin-top: 12px;
    margin-left: 13px;
}

.trial-content .content-img {
    width: 1200px;
    height: 750px;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid #82CAFF;
    margin-top: 48px;
    margin-bottom: 48px;
}

.trial-content .content-img img {
    width: 100%;
    height: 100%;
}

.trial-content .end-page {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background-image: url('../../assets/images/end-page.jpg');
    background-size: 100% 100%;
    width: 100%;
    height: 100%;


}

.trial-content .end-page .tips {
    font-size: 24px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 28px;
}

.trial-content .end-page .buy-button {
    width: 103px;
    height: 46px;
    background: #0047FF;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    margin-top: 24px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/views/trial/index.vue